/**
 * Education Empire — Phase 27
 * Tab navigation, counters, scroll reveal, enrollment persistence
 */
(function () {
  'use strict';

  /* ── Counter Animation ── */
  function animateCounter(el, target, duration) {
    if (!el) return;
    var numericTarget = parseInt(target, 10);
    if (isNaN(numericTarget)) return;
    var suffix = '';
    if (target.indexOf('+') > -1) suffix = '+';
    if (target.indexOf('%') > -1) suffix = '%';
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var p = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var current = Math.round(eased * numericTarget);
      el.textContent = current >= 1000
        ? current.toLocaleString('en-IN') + suffix
        : current + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ── Intersection Observer ── */
  function onVisible(selector, callback, opts) {
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          callback(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, Object.assign({ threshold: 0.2 }, opts || {}));
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── Tab Navigation ── */
  var tabs = document.querySelectorAll('.edu-tab');
  var panels = document.querySelectorAll('.edu-panel');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = this.dataset.tab;
      tabs.forEach(function (t) { t.classList.remove('edu-active'); });
      this.classList.add('edu-active');
      panels.forEach(function (p) {
        p.classList.toggle('edu-visible', p.dataset.panel === target);
      });
    });
  });

  /* ── Hero Counters ── */
  onVisible('.edu-hero__stats', function () {
    document.querySelectorAll('.edu-hero__stat-num[data-counter]').forEach(function (el) {
      animateCounter(el, el.dataset.counter, 2200);
    });
  });

  /* ── Panel Counters ── */
  onVisible('.edu-certs, .edu-yt-hero', function (el) {
    el.querySelectorAll('[data-counter]').forEach(function (c) {
      animateCounter(c, c.dataset.counter, 2000);
    });
  }, { threshold: 0.1 });

  /* ── Scroll Reveal ── */
  onVisible('.edu-course, .edu-cert, .edu-pillar, .edu-video, .edu-pub, .edu-partner, .edu-program', function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      });
    });
  }, { threshold: 0.1 });

  /* ── Enrollment bar animation ── */
  onVisible('.edu-course__enrolled-fill', function (el) {
    var w = el.style.width;
    el.style.width = '0%';
    setTimeout(function () { el.style.width = w; }, 200);
  }, { threshold: 0.3 });

})();
